export default "__VITE_PUBLIC_ASSET__7a77c86d__"